<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="g-common-top-header">
        <!-- <div v-if="!this.$route.query.stid" style="float: left; width: 100%;">
          <a href="javascript:void(0)" style="color: black;">手工录入</a>
          <span style="margin: 0 5px">|</span>
          <a href="javascript:void(0)" @click="gpTextAdd">文本批量录入</a>
          <span style="margin: 0 5px">|</span>
          <a href="javascript:void(0)" @click="dialogVisible = true">Excel导入</a>
        </div> -->

        <!-- <el-form :inline="true"  ref="formImportExcel" :model="formImportExcel" label-width="80px">
            <el-dialog title="Excel批量导入试题" :visible.sync="dialogVisible" width="50%"
              :before-close="handleClose"
            >
              <span>支持“单选题、多选题、判断题、填空题、问答题、语音题”六类题型的导入，其中选择题最多支持 8个选项。</span>
              <el-divider></el-divider>
              <div style="margin: 30px 0px 50px 30px;">
                <div>
                    <span>第一步: 下载Excel试题导入模板</span>
                </div>
                <div>
                    <el-form-item>
                    <el-button class="button_color" size="mini" @click="downloadExcel">
                      试题导入模板（点击下载）
                    </el-button>
                    </el-form-item>
                </div>
                    <div>
                        <span>第二步: 上传导入文件</span>
                    </div>
                <div>
                    <el-form-item prop="file">
                      <el-upload
                        ref="upload"
                        :limit="1"
                        :auto-upload="false"
                        accept=".xls"
                        name="fileName"
                        action="#"
                        :before-upload="beforeUploadFile"
                        :on-exceed="exceedFile"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        :http-request="customUpload">
                        <el-button type="primary" plain size="mini" class="up_button_color">
                        <i class="el-icon-upload el-icon--right"></i>
                          上传导入文件
                        </el-button>
                      </el-upload>
                    </el-form-item>
                </div>
              </div>

              <el-divider></el-divider>
              <span slot="footer" class="dialog-footer" style=" display:block; text-align:center">
                <el-button type="primary" @click="importByExcel">导 入</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
              </span>
            </el-dialog>
          </el-form> -->

        <!-- <div v-if="!this.$route.query.stid" class="g-tab-ctn">
          <div @click="switchTab(key, item)" v-for="(item, key) in constant.tabs02" :class="item.class01" :key="key">
            <span>{{ item.text }}</span>
          </div>
        </div> -->

        <!-- 试题所属标签：{{ $route.query.tags }} -->
      </div>
      <!-- <div class="set">
        <span>基本设置</span>
      </div> -->

      <div class="g-common-ctn" v-if="$route.query.importType == 'excel'">
        <div style="width: 60%; height: 60%; margin: 30px auto">
          <el-form
            :inline="true"
            ref="formImportExcel"
            :model="formImportExcel"
            label-width="80px"
          >
            <span
              >支持“单选题、多选题、判断题、填空题、问答题、语音题”六类题型的导入，其中选择题最多支持
              8个选项。</span
            >
            <el-divider></el-divider>
            <div style="margin: 30px 0px 50px 30px">
              <div>
                <span>第一步: 下载Excel试题导入模板</span>
              </div>
              <div>
                <el-form-item>
                  <el-button
                    class="button_color"
                    size="mini"
                    @click="downloadExcel"
                  >
                    试题导入模板（点击下载）
                  </el-button>
                </el-form-item>
              </div>
              <div>
                <span>第二步: 上传导入文件</span>
              </div>
              <div>
                <el-form-item prop="file">
                  <el-upload
                    ref="upload"
                    :limit="1"
                    :auto-upload="true"
                    accept=".xls"
                    name="fileName"
                    action="#"
                    :show-file-list="false"
                    :before-upload="beforeUploadFile"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :file-list="fileList"
                    :http-request="httpRequest"
                  >
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      class="up_button_color"
                    >
                      <i class="el-icon-upload el-icon--right"></i>
                      上传导入文件
                    </el-button>
                  </el-upload>
                  <div class="file-list">
                    <div
                      class="file-item"
                      v-for="(item, index) in fileList"
                      :key="index"
                    >
                      <div class="file-info">
                        <i class="el-icon-document"></i>
                        {{ item.name }}
                      </div>
                      <i class="el-icon-close" @click="removeFile(index)"></i>

                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <div style="text-align: center">
            <el-button type="primary" @click="importByExcel"
              >开始导入</el-button
            >
          </div>
        </div>
      </div>

      <!-- <div class="g-common-ctn" v-if="currentTab == 'text'">
        请到跳转的新窗口进行操作
      </div> -->

      <div
        class="g-common-ctn"
        style="padding-bottom: 20px"
        v-else-if="$route.query.importType == 'manual'"
      >
        <div style="height: calc(100% - 55px); overflow: auto">
          <div>
            <el-form
              ref="commonForm"
              :model="commonForm"
              v-model="commonForm"
              label-width="40px"
              style="padding-top: 10px"
            >
              <div style="display: flex; justify-content: flex-start">
                <el-form-item
                  :required="true"
                  label="试题分类"
                  label-width="45%"
                >
                  <classify
                    :value.sync="flbh"
                    type="questions"
                    style="width: 200px"
                    placeholder="请选择试题分类"
                    size="small"
                  >
                  </classify>
                </el-form-item>
                <el-form-item label="难度" label-width="200px">
                  <el-radio v-model="level" label="1">简单</el-radio>
                  <el-radio v-model="level" label="2">普通</el-radio>
                  <el-radio v-model="level" label="3">困难</el-radio>
                </el-form-item>
                <el-form-item label="题型" label-width="80px">
                  <el-select
                    v-model="tx_dmms"
                    :disabled="this.txjy"
                    @change="seleteGet"
                  >
                    <el-option
                      v-for="item in typeOfQuestionItem"
                      :key="item.dmz"
                      :label="item.dmms"
                      :value="item.dmz"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div style="display: flex; justify-content: flex-start">
                <el-form-item
                  :required="true"
                  label="题干"
                  label-width="60px"
                  style="width: 100%; font-size: 16px"
                >
                  <strong
                    v-if="tx_dmms == '填空题'"
                    class="global-dark-blue"
                    style="font-size: 14px"
                    >&emsp;
                    <pre>
题干中可使用以下任意一种符号标识填空内容：
（1）使用中文小括号（）
（2）使用5个英文下划线 _____</pre
                    >
                  </strong>
                  <div class="editorDiv" id="stnr"></div>
                  <div
                    class="editorBox"
                    v-html="stnr || '<br/>'"
                    @click="showEditor('stnr')"
                  ></div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <!-- 单选题 -->
          <div v-if="tx_dmms == '单选题'">
            <el-form>
              <el-form-item :required="true" label="选项" label-width="60px">
                <strong class="global-dark-blue" style="font-size: 14px"
                  >&emsp;至少需要两个选项，勾选选项设置答案</strong
                >
              </el-form-item>
            </el-form>
            <el-form
              :model="dynamicValidateForm"
              ref="dynamicValidateForm"
              label-width="20px"
              class="demo-dynamic"
            >
              <el-form-item
                v-for="(domain, index) in dynamicValidateForm.domains"
                :key="domain.key"
                :prop="'domains.' + index + '.value'"
                style="width: 96%; margin-bottom: 8"
              >
                <el-radio
                  v-model="radio"
                  :label="index"
                  style="margin-right: 0; margin-bottom: 15px; width: 50px"
                >
                  {{ options[index] }}</el-radio
                >
                <div
                  class="editorDiv"
                  style="width: 95%"
                  :id="'xxnr' + index"
                ></div>
                <div
                  class="editorBox"
                  v-html="domain.xxnr || domain.value || '<br/>'"
                  @click="showEditor('xxnr' + index, domain, 'xxnr', 100)"
                ></div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addDomain"
                  >添加单个选项</el-button
                >
                <el-button type="danger" @click="removeDomain"
                  >删除单个选项</el-button
                >
                <el-button type="primary" @click="showBetchDialog()"
                  >批量添加选项</el-button
                >

                <el-dialog
                  title="批量添加选项"
                  :visible.sync="dialogBatchVisible"
                >
                  <span style="padding-left: 10px; color: red"
                    >每个选项用换行区分开</span
                  >
                  <el-input
                    type="textarea"
                    :rows="6"
                    v-model="batch"
                    style="width: 99%"
                  ></el-input>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogBatchVisible = false"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="batchOpt"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 多选题 -->
          <div v-if="tx_dmms == '多选题'">
            <el-form>
              <el-form-item :required="true" label="选项" label-width="60px">
                <strong class="global-dark-blue" style="font-size: 14px"
                  >&emsp;至少需要两个选项，勾选选项设置答案</strong
                >
              </el-form-item>
            </el-form>
            <el-form
              :model="dynamicValidateForm"
              ref="dynamicValidateForm"
              label-width="20px"
              style="width: 100%"
              class="demo-dynamic"
            >
              <el-form-item
                v-for="(domain, index) in dynamicValidateForm.domains"
                :key="domain.key"
                :prop="'domains.' + index + '.value'"
                style="width: 96%; margin-bottom: 8"
              >
                <el-checkbox
                  v-model="domain.check"
                  style="margin-right: 0; margin-bottom: 10px; width: 3.5%"
                  >{{ options[index] }}</el-checkbox
                >
                <div
                  class="editorDiv"
                  style="width: 95%"
                  :id="'xxnr' + index"
                ></div>
                <div
                  class="editorBox"
                  v-html="domain.xxnr || domain.value || '<br/>'"
                  @click="showEditor('xxnr' + index, domain, 'xxnr', 100)"
                ></div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addDomain"
                  >添加单个选项</el-button
                >
                <el-button type="danger" @click="removeDomain"
                  >删除单个选项</el-button
                >
                <el-button type="primary" @click="dialogBatchVisible = true"
                  >批量添加选项</el-button
                >

                <el-dialog
                  title="批量添加选项"
                  :visible.sync="dialogBatchVisible"
                >
                  <span style="padding-left: 10px; color: red"
                    >每个选项用换行区分开</span
                  >
                  <el-input
                    type="textarea"
                    :rows="6"
                    v-model="batch"
                    style="width: 99%"
                  ></el-input>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogBatchVisible = false"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="batchOpt"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 填空题 -->
          <div v-if="tx_dmms == '填空题'">
            <!--
                <label style="padding-left:30px;font-size:14px">
                  输入框大小：
                  <el-select v-model="value" placeholder="请选择" size="mini">
                    <el-option
                      v-for="item in size"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </label>
                -->
            <!-- <el-row>
              <el-col style="width: 60px; text-align: right; padding-right: 12px;"><span style="color:red">*</span><span>答案</span></el-col>
              <el-col style="width: 800px;">
                <span style="color:blue; font-size:12px">至少有一个填空，题干中() 表示填空内容</span>
                <label style="padding-left:30px;font-size:14px">
                  <el-checkbox v-model="bfxh" true-label="1" false-label="0">判分时不区分答案先后顺序</el-checkbox>
                </label>
              </el-col>
            </el-row> -->
            <el-form>
              <el-form-item :required="true" label="答案" label-width="60px">
                <div style="display: flex">
                  <strong class="global-dark-blue" style="font-size: 14px"
                    >&emsp;
                    <pre>至少添加一个填空答案</pre>
                  </strong>
                  <label style="padding-left: 30px; font-size: 14px">
                    <el-checkbox v-model="bfxh" true-label="1" false-label="0"
                      >判分时不区分答案先后顺序</el-checkbox
                    >
                  </label>
                </div>
              </el-form-item>
            </el-form>
            <el-form
              :model="answerForm"
              ref="answerForm"
              label-width="20px"
              class="demo-dynamic"
            >
              <el-form-item
                v-for="(answer, index) in answerForm.answers"
                :key="answer.key"
                :prop="'answers.' + index + '.value'"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="answer.value"
                  style="width: 90%; padding-left: 3%"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="60px">
                <el-button type="primary" @click="addAnswer"
                  >添加一个填空</el-button
                >

                <el-button type="danger" @click="removeTk"
                  >删除一个填空</el-button
                >
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 判断题 -->
          <div v-if="tx_dmms == '判断题'">
            <el-form>
              <el-form-item
                :required="true"
                label="答案"
                label-width="60px"
                style="width: 100%; font-size: 16px"
              >
                <el-radio-group v-model="judgeans">
                  <el-radio-button label="正确"></el-radio-button>
                  <el-radio-button label="错误"></el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 简答题 -->
          <div v-if="tx_dmms == '简答题'">
            <el-form>
              <el-form-item
                :required="true"
                label="答案"
                label-width="60px"
                style="width: 100%; font-size: 16px"
              >
                <div class="editorDiv" id="textAnswer"></div>
                <div
                  class="editorBox"
                  v-html="textAnswer || '<br/>'"
                  @click="showEditor('textAnswer')"
                ></div>
              </el-form-item>
              <el-form-item label-width="60px" label="得分点">
                <div style="display: flex; justify-content: flex-start">
                  <span
                    class="set"
                    style="display: block; width: 50%; text-align: center"
                  >
                    得分关键词
                  </span>
                  <span
                    class="set"
                    style="
                      display: block;
                      width: 14%;
                      text-align: center;
                      margin-left: 8px;
                      margin-right: 10px;
                    "
                  >
                    得分比例（%）
                  </span>
                  <el-button type="primary" @click="addAnswer">添加</el-button>
                </div>
              </el-form-item>
            </el-form>
            <el-form label-width="5%" class="demo-dynamic">
              <el-form-item
                v-for="(answer, index) in answerForm.answers"
                :key="index"
                :prop="'answers.' + index + '.value'"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="answer.value"
                  style="width: 50%; padding-right: 8px"
                ></el-input>
                <el-input-number
                  style="width: 14%; padding: 0px 8px 10px 0px"
                  v-model="answer.scale"
                  :precision="0"
                  :controls="false"
                  :min="0"
                  :max="getMaxZb(answerForm.answers, index)"
                />
                <el-button type="danger" @click="removeAnswer(answer)"
                  >删除</el-button
                >
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 录音题 -->
          <div v-if="tx_dmms == '录音题'">
            <el-form>
              <el-form-item
                :required="true"
                label="答案"
                label-width="60px"
                style="width: 100%; font-size: 16px"
              >
                <div class="editorDiv" id="textAnswer"></div>
                <div
                  class="editorBox"
                  v-html="textAnswer || '<br/>'"
                  @click="showEditor('textAnswer')"
                ></div>
              </el-form-item>
              <el-form-item label="解析" label-width="60px">
                <div class="editorDiv" id="jx"></div>
                <div
                  class="editorBox"
                  v-html="jx || '<br/>'"
                  @click="showEditor('jx')"
                ></div>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div style="height: 55px; padding-top: 20px; text-align: center">
          <el-button type="primary" @click="saveOnly">保存</el-button>
          <!-- <el-button v-if="!this.$route.query.stid" type="primary" @click="saveContiune">
            保存&继续录入
          </el-button> -->
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import { baseURL } from '@/assets/js/config'
import { save, getTypeOfQuestion, selectStListkById } from '@/api/questions'
// getClassifyList
import wangeditor from '@/assets/js/editor/wangeditor.js'
import constant from '../../assets/js/constant'
import classify from '@/components/select/classify'
export default {
  data () {
    return {
      constant,
      currentTab: '',
      dialogVisible: false,
      flbh: null, // 题目分类
      flmc: '',
      level: '1', // 难度
      tx_dmz: '1', // 题目类型
      tx_dmms: '单选题', // 题目类型描述
      typeOfQuestionItem: [], // 题目类型列表
      editors: {}, // 富文本编辑器
      /* ---------------------------------- 初始化分界线 ---------------------------------- */
      ...this.$lodash.cloneDeep(constant.questionAddData)
    }
  },
  watch: {},
  components: {
    myHeader,
    classify
  },
  created () {
    this.getParams()
  },
  methods: {
    downloadExcel () {
      // 后台数据下载不能用ajqx请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('GET', baseURL + '/questions/questionExcel?', true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'

      const that = this
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          const filename = '考试云试题导入模板.xls'
          const a = document.createElement('a')
          // 创键临时url对象
          const url = URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url)
          that.$message.success('下载成功，请编辑后上传')
        }
      }
      xmlhttp.send()
    },
    // 立即上传
    importByExcel () {
      console.log(this.$refs.upload, this.fileList, 'this.$refs.upload')
      // this.$refs.upload.submit()
      if (this.fileList.length === 0) {
        this.$message.warning('请选择文件')
        return
      }
      this.customUpload({ file: this.fileList[0] })
    },
    // 导入
    // 文件超出个数限制时的钩子
    exceedFile (files, fileList) {
      // this.$message.warning('只能选择1个')
      // 替换策略：移除第一个文件，添加新文件
      // this.$confirm('文件数量超出限制，是否替换成最新的文件？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      // 移除第一个文件
      this.$refs.upload.clearFiles()
      this.fileList.shift()
      console.log(files, 'files')

      // 添加新文件（自动触发上传）
      this.fileList.push(...files)
      // })
      // .catch(() => {})
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile (file) {
      console.log(file, 'file')
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xls的文件')
        return false
      }
      if (size > 10) {
        this.$message.warning('文件大小不得超过10M')
        return false
      }
      return true
    },
    // 文件上传成功时的钩子
    handleSuccess (res, file, fileList) {
      this.$message.success('文件上传成功')
    },
    // 文件上传失败时的钩子
    handleError (res, file, fileList) {
      this.$message.error('文件上传失败')
    },
    httpRequest (obj) {
      this.fileList.push(obj.file)
    },
    removeFile (index) {
      this.fileList.splice(index, 1)
    },

    // 自定义上传方法
    customUpload (obj) {
      const loading = this.$Loading.service({
        lock: true,
        text: '正在导入中……'
      })
      const file = obj.file
      const params = new FormData()
      params.append('file', file)
      // 后台数据下载不能用ajax请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('POST', baseURL + '/questions/file', true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      const that = this
      xmlhttp.onreadystatechange = function () {
        loading.close()
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          // 如果返回的是json 则说明是成功的
          if (blob.type === 'application/json') {
            blob.text().then(data => {
              const res = JSON.parse(data)
              that.$http.callback(res, () => {
                that.$message.success(res.msg)
                that.dialogVisible = false
                that.fileList.splice(0)
                // that.query()
              })
            })
          } else {
            that.$message.error('部分数据导入失败，详情请查看附件')
            const a = document.createElement('a')
            // 创键临时url对象
            const url = URL.createObjectURL(blob)
            a.href = url
            a.download = '错误数据.xls'
            a.click()
            // 释放之前创建的URL对象
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xmlhttp.send(params)
    },

    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    getMaxZb (list, curIndex) {
      if (list && list.length > 0) {
        return (
          100.0 -
          list
            .filter((v, index) => index !== curIndex)
            .reduce((total, v) => total + (v.scale || 0), 0)
        )
      }
    },
    showEditor (divId, obj = this, key = divId, height = 200) {
      const that = this
      // 收缩其它富文本编辑器
      const otherEditorDivs = document.querySelectorAll(
        '.editorDiv:not([id=' + divId + '])'
      )
      otherEditorDivs.forEach(editorDiv => {
        editorDiv.nextElementSibling.style.display = 'inline-block'
        editorDiv.style.display = 'none'
      })
      // 显示当前富文本编辑器
      const editorDiv = document.getElementById(divId)
      editorDiv.nextElementSibling.style.display = 'none'
      editorDiv.style.display = 'inline-block'
      const isEditor = editorDiv.getAttribute('data-isEditor')
      // 初始化富文本编辑器
      if (!isEditor) {
        // 定义改变事件
        const config = {
          onchange: function (newHtml) {
            obj[key] = newHtml
            if (key.indexOf('stnr') !== -1) {
              obj.tg = that.editors[divId].txt.text()
            } else if (key.indexOf('xxnr') !== -1) {
              obj.value = that.editors[divId].txt.text()
            }
          },
          height: height
        }
        // 创建富文本框
        this.editors[divId] = wangeditor.createComplexEditor(editorDiv, config)
        if (key.indexOf('stnr') !== -1) {
          this.editors[divId].txt.html(obj[key] || obj.tg)
        } else if (key.indexOf('xxnr') !== -1) {
          this.editors[divId].txt.html(obj[key] || obj.value)
        } else {
          this.editors[divId].txt.html(obj[key])
        }
        editorDiv.setAttribute('data-isEditor', true)
      }
    },
    // switchTab (key, item) {
    //   this.currentTab = item.type
    //   for (let i = 0; i < this.constant.tabs02.length; i++) {
    //     if (key === i) {
    //       this.constant.tabs02[i].class01 = 'g-tab-clicked'
    //     } else {
    //       this.constant.tabs02[i].class01 = 'g-tab-unclicked'
    //     }
    //   }
    // },
    gpTextAdd () {
      const blank = this.$router.resolve({
        path: '/questions/textAdd'
      })
      window.open(blank.href, '_blank')
    },
    showBetchDialog () {
      this.batch = ''
      this.dialogBatchVisible = true
    },
    // 批量添加选项
    batchOpt () {
      const arr = this.batch.split(/[(\r\n)\r\n]+/)
      this.dialogBatchVisible = false
      // 删除空白选项
      for (let i = 0; i < this.dynamicValidateForm.domains.length; i++) {
        if (
          this.dynamicValidateForm.domains[i].value === '' ||
          this.dynamicValidateForm.domains[i].value === null
        ) {
          this.dynamicValidateForm.domains.splice(i, 1)
          i--
        }
      }
      // 添加选项
      const base = this.dynamicValidateForm.domains.length
      for (let i = 0; i < arr.length; i++) {
        this.dynamicValidateForm.domains.push({
          xxid: i + 1 + base,
          xsxh: i + 1 + base,
          value: arr[i],
          xxnr: arr[i],
          check: ''
        })
      }
    },
    // 编辑试题
    getParams () {
      const stid = this.$route.query.stid
      if (stid) {
        this.getStkInfo(stid)
      }
    },
    getStkInfo (stid) {
      this.txjy = true
      this.stid = stid
      const params = { stid: stid }
      selectStListkById(params).then(res => {
        this.$http.callback(res, () => {
          this.flbh = res.data.flbh
          this.flmc = res.data.flmc
          this.tg = res.data.tg
          this.stnr = res.data.stnr || res.data.tg
          this.level = res.data.nycd
          this.tx_dmz = res.data.tx
          this.tx_dmms = res.data.txmc
          this.jx = res.data.ksyStkStda.dajx
          // 单选 多选
          if (res.data.tx === '1' || res.data.tx === '2') {
            // 生成足够的输入框
            if (
              res.data.ksyStkStxxList.length <
              this.dynamicValidateForm.domains.length
            ) {
              for (
                let i = this.dynamicValidateForm.domains.length;
                i > res.data.ksyStkStxxList.length;
                i--
              ) {
                this.dynamicValidateForm.domains.pop()
              }
            } else {
              for (
                let i = this.dynamicValidateForm.domains.length;
                i < res.data.ksyStkStxxList.length;
                i++
              ) {
                this.dynamicValidateForm.domains.push({
                  xxid: i,
                  xsxh: i,
                  value: '',
                  check: ''
                })
              }
            }
            for (var i = 0; i < res.data.ksyStkStxxList.length; i++) {
              this.dynamicValidateForm.domains[i].xxnr =
                res.data.ksyStkStxxList[i].xxnr
              this.dynamicValidateForm.domains[i].value =
                res.data.ksyStkStxxList[i].xxsm
              this.dynamicValidateForm.domains[i].xxid =
                res.data.ksyStkStxxList[i].xxid
              this.dynamicValidateForm.domains[i].xsxh =
                res.data.ksyStkStxxList[i].xsxh
              // 判断正确答案
              if (res.data.ksyStkStxxList[i].sfdaxx === '1') {
                this.radio = i
                this.dynamicValidateForm.domains[i].check = true
              }
            }
          }
          // 填空题
          if (res.data.tx === '3') {
            this.bfxh = res.data.ksyStkStda.dabqfsx
            const arr = res.data.ksyStkStda.bzda.split('€')
            // 生成足够输入框
            for (var z = 0; z < arr.length; z++) {
              this.answerForm.answers.push({
                value: '',
                key: Date.now()
              })
            }
            for (var j = 0; j < arr.length; j++) {
              this.answerForm.answers[j].value = arr[j]
              this.answerForm.answers[j].xh = j
            }
          }
          // 判断题
          if (res.data.tx === '4') {
            if (res.data.ksyStkStda.bzda === '1') {
              this.judgeans = '正确'
            } else {
              this.judgeans = '错误'
            }
          }
          // 简答题
          if (res.data.tx === '5') {
            // 生成足够输入框
            this.textAnswer = res.data.ksyStkStda.bzda
            for (var x = 0; x < res.data.ksyStkDfdszList.length; x++) {
              this.answerForm.answers.push({
                value: '',
                scale: null,
                key: Date.now()
              })
            }
            for (var b = 0; b < res.data.ksyStkDfdszList.length; b++) {
              this.answerForm.answers[b].xh = res.data.ksyStkDfdszList[b].xh
              this.answerForm.answers[b].value =
                res.data.ksyStkDfdszList[b].dfgjc + ''
              this.answerForm.answers[b].scale =
                res.data.ksyStkDfdszList[b].dfbl
            }
          }
          // 录音题
          if (res.data.tx === '6') {
            // 生成足够输入框
            this.textAnswer = res.data.ksyStkStda.bzda
          }
        })
      })
    },
    // 获取选择题型dmz
    seleteGet (vid) {
      let obj = {}
      obj = this.typeOfQuestionItem.find(item => {
        return item.dmz === vid
      })
      this.tx_dmz = obj.dmz
      this.tx_dmms = obj.dmms
    },
    // 整理传入后台的数据
    setParams () {
      const user = this.$store.state.user
      if (user !== null) {
        this.yhmc = user.yhmc
        if (user.txdz) {
          this.userHead = user.txdz
        }
      }
      if (this.tx_dmms === '单选题') {
        const stda = {
          bzda: this.radio || this.radio === 0 ? this.radio + 1 : '',
          dajx: this.jx
        }
        this.ksyStkStda = stda
        this.KsyStkStxxList = []
        this.sfkbxx = this.dynamicValidateForm.domains.length
        for (let i = 0; i <= this.dynamicValidateForm.domains.length - 1; i++) {
          // 判断选项
          if (this.dynamicValidateForm.domains[i].value !== '') {
            this.sfkbxx = --this.sfkbxx
          }
          if (this.radio === i) {
            const obj = {
              xxid: this.dynamicValidateForm.domains[i].xxid,
              xxsm: this.dynamicValidateForm.domains[i].value,
              xsxh: this.dynamicValidateForm.domains[i].xsxh,
              sfdaxx: '1',
              xxnr: this.dynamicValidateForm.domains[i].xxnr
            }
            this.KsyStkStxxList.push(obj)
          } else {
            const obj = {
              xxid: this.dynamicValidateForm.domains[i].xxid,
              xxsm: this.dynamicValidateForm.domains[i].value,
              xsxh: this.dynamicValidateForm.domains[i].xsxh,
              sfdaxx: '0',
              xxnr: this.dynamicValidateForm.domains[i].xxnr
            }
            this.KsyStkStxxList.push(obj)
          }
        }
      } else if (this.tx_dmms === '多选题') {
        this.KsyStkStxxList = []
        let bzdadx = ''
        this.sfkbxx = this.dynamicValidateForm.domains.length
        for (let i = 0; i <= this.dynamicValidateForm.domains.length - 1; i++) {
          if (this.dynamicValidateForm.domains[i].value !== '') {
            this.sfkbxx = --this.sfkbxx
          }
          if (this.dynamicValidateForm.domains[i].check === true) {
            bzdadx = bzdadx + parseInt(i + 1) + '€'
            var objs = {
              xxid: this.dynamicValidateForm.domains[i].xxid,
              xxsm: this.dynamicValidateForm.domains[i].value,
              xsxh: this.dynamicValidateForm.domains[i].xsxh,
              sfdaxx: '1',
              xxnr: this.dynamicValidateForm.domains[i].xxnr
            }
            this.KsyStkStxxList.push(objs)
          } else {
            objs = {
              xxid: this.dynamicValidateForm.domains[i].xxid,
              xxsm: this.dynamicValidateForm.domains[i].value,
              xsxh: this.dynamicValidateForm.domains[i].xsxh,
              sfdaxx: '0',
              xxnr: this.dynamicValidateForm.domains[i].xxnr
            }
            this.KsyStkStxxList.push(objs)
          }
        }
        const stda = {
          bzda: bzdadx ? bzdadx.substring(0, bzdadx.length - 1) : '',
          dajx: this.jx
        }
        this.ksyStkStda = stda
      } else if (this.tx_dmms === '填空题') {
        let bzdatk = ''
        this.sfkbxx = this.answerForm.answers.length
        for (let i = 0; i <= this.answerForm.answers.length - 1; i++) {
          if (this.answerForm.answers[i].value !== '') {
            this.sfkbxx = --this.sfkbxx
          }
          bzdatk = bzdatk + this.answerForm.answers[i].value + '€'
        }
        if (this.bfxh === '1') {
          const stda = {
            bzda: bzdatk.substring(0, bzdatk.length - 1),
            dajx: this.jx,
            dabqfsx: 1
          }
          this.ksyStkStda = stda
        } else {
          const stda = {
            bzda: bzdatk.substring(0, bzdatk.length - 1),
            dajx: this.jx,
            dabqfsx: 0
          }
          this.ksyStkStda = stda
        }
      } else if (this.tx_dmms === '判断题') {
        this.KsyStkStxxList = []
        const right = {
          xxid: 1,
          xxsm: '正确',
          xsxh: 1,
          sfdaxx: '0',
          xxnr: '正确'
        }
        const error = {
          xxid: 2,
          xxsm: '错误',
          xsxh: 2,
          sfdaxx: '0',
          xxnr: '错误'
        }
        if (this.judgeans === '正确') {
          this.judgeans = '1'
          right.sfdaxx = '1'
        } else if (this.judgeans === '错误') {
          this.judgeans = '2'
          error.sfdaxx = '1'
        } else {
          this.judgeans = ''
        }
        const stda = { bzda: this.judgeans, dajx: this.jx }
        this.ksyStkStda = stda
        this.KsyStkStxxList.push(right, error) // 给判断题 添加两个选项 zhuqx 20200713 add
      } else if (this.tx_dmms === '简答题') {
        this.KsyStkDfdszList = []
        this.sfkbxx = this.answerForm.answers.length
        for (let i = 0; i <= this.answerForm.answers.length - 1; i++) {
          if (this.answerForm.answers[i].value !== '') {
            this.sfkbxx = --this.sfkbxx
          }
          var dfd = {
            dfbl: this.answerForm.answers[i].scale,
            xh: this.answerForm.answers[i].xh,
            dfgjc: this.answerForm.answers[i].value
          }
          this.KsyStkDfdszList.push(dfd)
        }
        const stda = { bzda: this.textAnswer, dajx: this.jx }
        this.ksyStkStda = stda
      } else if (this.tx_dmms === '录音题') {
        const stda = { bzda: this.textAnswer || '-', dajx: this.jx }
        this.ksyStkStda = stda
      }
      const params = {
        flbh: this.flbh,
        nycd: this.level,
        tx: this.tx_dmz,
        tg: this.tg,
        stnr: this.stnr,
        ksyStkStxxList: this.KsyStkStxxList,
        ksyStkDfdszList: this.KsyStkDfdszList,
        ksyStkStda: this.ksyStkStda
      }
      // 如是页面中有stid，则为编辑，将stid传入后台
      if (this.stid) {
        params.stid = this.stid
      }
      this.params = params
    },
    // 检查得分点是否合为100
    checkDfd () {
      if (this.params.ksyStkDfdszList.length !== 0) {
        var zf = 0
        for (let i = 0; i < this.answerForm.answers.length; i++) {
          zf = zf + parseInt(this.answerForm.answers[i].scale)
        }
        if (zf !== 100) {
          this.KsyStkDfdszList.length = 0
          this.$message.warning('设置得分点后，得分比例必须为100')
          return false
        }
        return true
      } else {
        return true
      }
    },
    save (callbackFun) {
      this.setParams()
      // 简答题检查得分比例是否为100
      if (this.tx_dmms === '简答题') {
        if (!this.checkDfd()) {
          return
        }
      }
      // 试题分类与题干不可为空
      if (!this.flbh) {
        this.$message.warning('试题分类不可为空')
      } else if (this.stnr === '') {
        this.$message.warning('题干不可为空')
      } else if (this.tg.length > 2000) {
        this.$message.warning('题干字数超长')
      } else if (this.stnr.length > 50000) {
        this.$message.warning('题干内容超长，如果存在表格样式，建议改成截图')
      } else {
        // 是否录入了答案
        if (
          (this.tx_dmms === '单选题' && this.ksyStkStda.bzda === '') ||
          (this.tx_dmms === '多选题' && this.ksyStkStda.bzda === '') ||
          (this.tx_dmms === '判断题' && this.ksyStkStda.bzda === '')
        ) {
          // 清空list中内容，否则数据会重复
          this.KsyStkStxxList.length = 0
          this.$message.warning('请选择正确选项')
        } else if (
          (this.tx_dmms === '填空题' && this.ksyStkStda.bzda === '') ||
          (this.tx_dmms === '简答题' && this.ksyStkStda.bzda === '')
        ) {
          this.KsyStkDfdszList.length = 0
          this.$message.warning('请输入正确答案')
        } else if (this.sfkbxx !== 0) {
          // 是否含空白选项，清空list中的内容
          this.KsyStkStxxList.length = 0
          this.KsyStkDfdszList.length = 0
          this.$message.warning('请将空白答案处补充完整')
        } else {
          if (this.zfbz === 0) {
            save(this.params).then(res => {
              this.$http.callback(res, () => {
                callbackFun && callbackFun(res)
              })
            })
          }
        }
      }
    },
    // 保存
    saveOnly () {
      this.save(res => {
        if (!this.$route.query.stid) {
          this.$confirm('是否继续录入？', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$message.success(res.msg)
              // 初始化this.data
              Object.assign(
                this,
                this.$lodash.cloneDeep(constant.questionAddData)
              )
              // 解决由于重新赋值造成的this失去响应
              const tempDmms = this.tx_dmms
              this.tx_dmms = ''
              this.$nextTick(() => {
                this.tx_dmms = tempDmms
                this.$nextTick(() => {
                  console.log(this.editors)
                  // 清空所有富文本编辑框
                  this.$lodash.each(this.editors, (editor, key) => {
                    editor.txt.html('')
                  })
                })
              })
            })
            .catch(() => {
              this.$router.push({
                path: '/questions/list'
              })
              this.$message.success(res.msg)
            })
        } else {
          this.$router.push({
            path: '/questions/list'
          })
          this.$message.success(res.msg)
        }
      })
    },
    // 保存&&继续录入
    saveContiune () {
      this.save(res => {
        this.$message.success(res.msg)
        // 初始化this.data
        Object.assign(this, this.$lodash.cloneDeep(constant.questionAddData))
        // 解决由于重新赋值造成的this失去响应
        const tempDmms = this.tx_dmms
        this.tx_dmms = ''
        this.$nextTick(() => {
          this.tx_dmms = tempDmms
          this.$nextTick(() => {
            console.log(this.editors)
            // 清空所有富文本编辑框
            this.$lodash.each(this.editors, (editor, key) => {
              editor.txt.html('')
            })
          })
        })
      })
    },
    // 保存&&创建考试
    saveEstablish () {
      this.save()
      this.checkDfd()
      if (this.zfbz === 1) {
        return
      }
      save(this.params).then(res => {
        this.$http.callback(res, () => {
          if (res.code === 200) {
            this.$router.push({
              path: '/examPaper/edit'
            })
          }
          this.$message.success(res.msg)
        })
      })
    },
    // 删除多余单选、多选选项
    removeDomain () {
      if (this.dynamicValidateForm.domains.length <= 2) {
        this.$message.warning('选择题必须保留两个选项')
        return
      }
      if (this.radio === this.dynamicValidateForm.domains.length - 1) {
        this.radio = ''
      }
      this.dynamicValidateForm.domains.splice(
        this.dynamicValidateForm.domains.length - 1,
        1
      )
    },
    // 增加单选、多选选项
    addDomain () {
      this.dynamicValidateForm.domains.push({
        xxid: this.dynamicValidateForm.domains.length + 1,
        xsxh: this.dynamicValidateForm.domains.length + 1,
        value: '',
        key: Date.now()
      })
    },
    // 删除多余填空
    removeTk () {
      if (this.answerForm.answers.length <= 1) {
        this.$message.warning('填空题必须保留一个填空')
        return
      }
      this.answerForm.answers.splice(this.answerForm.answers.length - 1, 1)
    },
    // 删除多余得分点
    removeAnswer (item) {
      var index = this.answerForm.answers.indexOf(item)
      if (index !== -1) {
        this.answerForm.answers.splice(index, 1)
      }
    },
    // 添加得分点
    addAnswer () {
      this.answerForm.answers.push({
        xh: this.answerForm.answers.length + 1,
        value: '',
        scale: null,
        key: Date.now()
      })
    },
    // 获取题型、试题分类、编辑试题时试题分类名称
    typeOfQuestion () {
      getTypeOfQuestion().then(res => {
        this.typeOfQuestionItem = res.data
      })
      // getClassifyList().then(res => {
      //   this.$http.callback(res, () => {
      //     this.parseTree(res.data)
      //   })
      // })
    }
  },
  mounted () {
    this.typeOfQuestion()
    // this.switchTab(0, this.constant.tabs02[0])
  }
}
</script>

<style lang="less" scoped>
#stfltree {
  /deep/ * {
    font-weight: normal !important;
  }
}
.set {
  background-color: #f4f5f7;
  height: 30px;
  line-height: 30px;
}
/*
.set:hover{
  background-color: #D2E3EE;
}
*/
.button_color {
  border-color: #00f;
  color: #00f;
  margin: 15px 0px 0px 0px;
}

.up_button_color {
  margin: 15px 0px 0px 0px;
}
.file-list {
  .file-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding: 0 4px;
    border-radius: 4px;
    cursor: pointer;
    .file-info {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover{
      .file-info{
        color: #007bff;
      }
      background-color: #f8f9fa;
    }
  }
}
</style>
